<template>
  <div class="home wrapper">
    <div class="content">
      <Header></Header>
      <Loading :loading="loading"></Loading>

      <div :class="{ 'hidden': loading }">
        <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>
        <Title :title="categoryName"></Title>

        <div class="container items-container">
          <div class="row">
            <div class="col-12">
              <div class="employees-filter">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <select class="form-control" v-model="branch">
                        <option value="">Subseção/Seccional</option>

                        <option :value="filial.name" v-for="filial in branchs">{{ filial.name }}</option>

                      </select>
                      <!-- /.form-control -->
                    </div>
                  </div>
                  <!-- /.col-12 col-md-6 -->

                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <input class="form-control" type="text" v-model="search" placeholder="Digite o nome..."/>
                    </div>
                    <!-- /.form-group -->
                  </div>
                  <!-- /.col-12 col-md-6 -->
                </div>
                <!-- /.row -->
              </div>
              <!-- /.employees-filter -->
            </div>
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->

        <div class="container items-container">
          <div class="row">
            <div :class="{ 'col-12 hidden': loading, 'col-12': !loading }">

              <div class="employees-list-header js-list-header">
                <ul>
                  <li class="employees-list-header-name">
                    Nome
                  </li>
                  <!-- /.employees-list-header-item -->
                  <li class="employees-list-header-role">
                    Função
                  </li>
                  <!-- /.employees-list-header-item -->
                  <li class="employees-list-header-adminission">
                    Admissão
                  </li>
                  <!-- /.employees-list-header-item -->
                </ul>
              </div>
              <!-- /.employees-list-header -->

              <div class="employees">
                <ul class="employees-list">
                  <li class="employees-item" v-for="person in filteredList">
                    <div class="employees-item-name">
                      <span>{{ person.name }}</span>
                      <small>Nome</small>
                    </div>
                    <!-- /.employees-item-name -->

                    <div class="employees-item-role">
                      <span>{{ person.role }}</span>
                      <small>Função</small>
                    </div>
                    <!-- /.employees-item-role -->

                    <div class="employees-item-adminission">
                      <span>{{ person.adminission }}</span>
                      <small>Admissão</small>
                    </div>
                    <!-- /.employees-item-adminission -->
                  </li>
                  <!-- /.employees-item -->
                </ul>
                <!-- /.employees-list -->
              </div>
              <!-- /.employees -->

            </div>
            <!--== /.col-12 ==-->
          </div>
          <!-- /.row -->
        </div>
        <!-- /.container -->

      </div>
      <!--== /.hidden ==-->
    </div>
    <!-- /.content -->

    <Footer></Footer>
  </div>
  <!-- /.home wrapper -->
</template>

<script>
  import Header from '../../components/Header.vue';
  import Footer from '../../components/Footer.vue';
  import Breadcrumb from '../../components/Breadcrumb.vue';
  import Title from '../../components/generic/Title.vue';
  import Loading from '../../components/generic/Loading.vue';
  import axios from 'axios';
  import env from '../../config/env';

  export default {
    name: 'category',
    components: {
      Header,
      Footer,
      Breadcrumb,
      Title,
      Loading,
    },
    data () {
      return {
        search: '',
        branch: '',
        categoryName: 'Colaboradores',
        peopleList: [],
        loading: true,
        branchs: [],
        breadcrumbs: [
          {
            name: 'Início',
            link: '/'
          },
          {
            name: 'Gestão e Governança',
            link: '/gestaodepessoas'
          }
        ]
      }
    },
    computed: {
      filteredList() {
        let vm = this,
          search = vm.search,
          branch = vm.branch;

        if(search === "" && branch === "") {
          return vm.peopleList;
        } else {
          return vm.peopleList.filter((person) => {
            return (search === '' || person.name.toLowerCase().includes(this.search.toLowerCase())) && (person.branch.toLowerCase().includes(this.branch.toLowerCase()));
          });
        }
      }
    },
    mounted () {
      axios
        .get(env.api.FILIAIS)
        .then(response => {
          this.branchs = response.data;
        });

      axios
        .get(`${env.api.COLABORADORES}/${this.$route.params.category}`)
        .then(response => {
          this.peopleList = response.data.items;
          this.categoryName = response.data.categoryName;
          this.loading = false;

          this.breadcrumbs.push({
            name: this.categoryName
          });
        });
    }
  };

  jQuery(document).ready(function ($) {
    if ($(window).width() >= 1024) {
      $(window).scroll(() => {
        let $cache = $('.js-list-header');
        if ($(window).scrollTop() > 175)
          $cache.addClass('header-fixed');
        else
          $cache.removeClass('header-fixed');
      });
    }
  }(jQuery));
</script>

<style lang="scss" scoped>
  .employees-list-header {
    display: none;
  }

  .header-fixed {
    position: fixed !important;
    top: 100px;
  }

  .employees-list-header,
  .employees {
    ul {
      padding: 0;
      margin: 0;

      li {
        padding: 10px;

        list-style: none;

        background-color: #ffffff;

        &:nth-of-type(odd) {
          background-color: #f1f1f1;
        }
      }
    }
  }

  .employees-list-header-item,
  .employees-item {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    font-family: 'Lato', sans-serif;
    line-height: 1;

    span {
      display: block;

      color: #333333;
    }

    small {
      font-weight: 700;
      color: #000000;
    }
  }

  .employees-item-name {
    flex: 0 0 100%;
  }

  .employees-item-role,
  .employees-item-adminission {
    flex: 0 0 50%;
    margin-top: 10px;
  }

  .employees-filter {
    select,
    input {
      height: 50px;

      font-family: 'Lato', sans-serif;
      font-size: 20px;
      font-weight: 300;

      box-shadow: none;
    }
  }

  @media (min-width: 768px) {
    .employees-list-header-name,
    .employees-item-name {
      flex: 0 0 47%;
    }

    .employees-list-header-role,
    .employees-item-role {
      flex: 0 0 30%;

      margin: 0;
    }

    .employees-list-header-adminission,
    .employees-item-adminission {
      flex: 0 0 13%;

      margin: 0;
    }
  }

  @media (min-width: 1024px) {
    .employees-item {
      padding: 20px 10px !important;

      small {
        display: none;
      }
    }

    .employees-list-header {
      display: block !important;
      width: 1110px;

      ul {
        display: flex;
        justify-content: space-between;
      }

      ul,
      li {
        background-color: #c34338 !important;
      }

      li {
        padding: 20px 10px !important;

        font-weight: 700;
        color: #ffffff;
      }
    }
  }
</style>
